import Vue from "vue";

Vue.mixin({
    props: {
        // used to override the sfc template - takes an html elements id (#el-id)
        templateOverride: {
            type: String,
            default: ""
        }
    },

    created()
    {
        const override = this.$props?.templateOverride || this.$props?.template;

        if (override)
        {
            this.$options.template = override;
        }
    }
});
